import { useTemplateContext } from './TemplateProvider'

/**
 * Main template hook - provides access to all template functionality
 * Use this when you need full template context access
 */
export const useTemplate = () => {
	const context = useTemplateContext()
	return context
}

/**
 * Template selection hook - focused on template selection and data
 * Use this in components that need to display and select templates
 */
export const useTemplateSelection = () => {
	const { templates, selectedTemplateId, selectedTemplate, selectTemplate } = useTemplateContext()

	return {
		templates,
		selectedTemplateId,
		selectedTemplate,
		selectTemplate,
	}
}

/**
 * Template actions hook - focused on template manipulation operations
 * Use this in components that need to save, create, or modify templates
 */
export const useTemplateActions = () => {
	const { selectTemplate, applyTemplateToContent, saveTemplate, saveAsNewTemplate } = useTemplateContext()

	return {
		selectTemplate,
		applyTemplateToContent,
		saveTemplate,
		saveAsNewTemplate,
	}
}

/**
 * Template state hook - focused on template state information
 * Use this in components that need to display template status
 */
export const useTemplateState = () => {
	const { selectedTemplateId, selectedTemplate, templates } = useTemplateContext()

	// Computed state values
	const hasSelectedTemplate = selectedTemplate !== null
	const templateCount = templates.length
	const selectedTemplateName = selectedTemplate?.name ?? 'No template selected'

	return {
		selectedTemplateId,
		selectedTemplate,
		hasSelectedTemplate,
		templateCount,
		selectedTemplateName,
	}
}
